import React from 'react';
import PropTypes from 'prop-types';

import {greyishBlue100} from "assets/jss/main";
import {UserAgentUtils} from "../../../../../../utils/useragent";

TopTableContainer.propTypes = {
    children: PropTypes.node,
};

function TopTableContainer(props) {
    const isMobile = UserAgentUtils.isMobile();

    return (
        <div
            style={{
                backgroundColor: isMobile ? 'none': "#fff",
                borderRadius: isMobile ? '0' : "0px 0px 12px 12px",
                border: isMobile ? 'none' : `1px solid ${greyishBlue100}`,
                borderTop: 'none',
                margin: 0
            }}
        >
            {props.children}
        </div>
    );
}

export default TopTableContainer;
